/* src/app/front-layout/blogs-read/blogs-read.component.css */
.blogs-cont {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding: 0;
  margin-top: 120px;
}
.back-button-container {
  width: 100%;
  max-width: 1200px;
  padding: 20px 20px 10px;
}
.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
}
.back-button:hover {
  background-color: #f5f5f5;
  border-color: #00BCD4;
  color: #00BCD4;
}
.back-button svg {
  transition: transform 0.3s ease;
}
.back-button:hover svg {
  transform: translateX(-3px);
}
.pub-header {
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 40px 20px 20px;
  font-size: 14px;
  color: #666;
}
.pub-date {
  font-weight: 500;
}
.pub-author {
  position: relative;
  padding-left: 15px;
}
.pub-author::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #666;
}
.blog-title {
  width: 100%;
  max-width: 1200px;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin: 20px 20px 15px;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}
.blog-subtitle {
  width: 100%;
  max-width: 1200px;
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin: 0 20px 25px;
  font-weight: 400;
}
.blog-tags {
  width: 100%;
  max-width: 1200px;
  display: flex;
  gap: 10px;
  padding: 0 20px 30px;
  flex-wrap: wrap;
}
.tag {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.tag:nth-child(1) {
  background-color: #E0F7FA;
  color: #00838F;
}
.tag:nth-child(2) {
  background-color: #FCE4EC;
  color: #C2185B;
}
.tag:nth-child(3) {
  background-color: #FFF9C4;
  color: #F57F17;
}
.blog-banner {
  width: 100%;
  max-width: 1200px;
  margin: 0 20px 60px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}
.blog-banner img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
  transform: perspective(1000px) rotateY(-2deg);
  transition: transform 0.3s ease;
}
.blog-banner:hover img {
  transform: perspective(1000px) rotateY(0deg);
}
.blog-content-wrapper {
  width: 100%;
  max-width: 1200px;
}
.section-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 25px;
  letter-spacing: -0.3px;
}
.blog-content {
  font-size: 18px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 40px;
}
.blog-content p {
  margin-bottom: 20px;
  text-align: justify;
}
.blog-content h2 {
  font-size: 32px;
  font-weight: 700;
  margin: 40px 0 20px;
  color: #1a1a1a;
}
.blog-content h3 {
  font-size: 24px;
  font-weight: 600;
  margin: 30px 0 15px;
  color: #1a1a1a;
}
.blog-content blockquote {
  border-left: 4px solid #00BCD4;
  padding-left: 25px;
  margin: 30px 0;
  font-style: italic;
  color: #555;
  background-color: #f8f9fa;
  padding: 20px 25px;
  border-radius: 4px;
}
.blog-content ul,
.blog-content ol {
  margin: 20px 0;
  padding-left: 30px;
}
.blog-content li {
  margin-bottom: 10px;
}
.blog-content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 30px 0;
}
.blog-content a {
  color: #00BCD4;
  text-decoration: none;
  border-bottom: 1px solid #00BCD4;
  transition: color 0.3s ease;
}
.blog-content a:hover {
  color: #0097A7;
  border-bottom-color: #0097A7;
}
.loading-container {
  width: 100%;
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
}
@media (max-width: 768px) {
  .blogs-cont {
    margin-top: 100px;
  }
  .back-button-container {
    padding: 15px 20px 10px;
  }
  .back-button {
    padding: 8px 16px;
    font-size: 14px;
  }
  .pub-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    padding: 25px 20px 15px;
    font-size: 13px;
  }
  .pub-author {
    padding-left: 0;
  }
  .pub-author::before {
    display: none;
  }
  .blog-title {
    max-width: 90%;
    font-size: 32px;
    margin: 10px;
    line-height: 1.25;
  }
  .blog-subtitle {
    font-size: 16px;
    margin: 0 20px 20px;
    line-height: 1.6;
  }
  .blog-tags {
    padding: 0 20px 25px;
    gap: 8px;
  }
  .tag {
    padding: 5px 14px;
    font-size: 12px;
  }
  .blog-banner {
    margin: 0 20px 40px;
    border-radius: 12px;
  }
  .blog-banner img {
    height: 280px;
    transform: none;
    object-fit: cover;
  }
  .blog-content-wrapper {
    padding: 0 20px 50px;
  }
  .section-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  .blog-content {
    font-size: 16px;
    line-height: 1.75;
  }
  .blog-content p {
    text-align: left;
    margin-bottom: 18px;
  }
  .blog-content h2 {
    font-size: 26px;
    margin: 35px 0 18px;
  }
  .blog-content h3 {
    font-size: 21px;
    margin: 28px 0 14px;
  }
  .blog-content blockquote {
    padding: 18px 20px;
    margin: 25px 0;
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .blogs-cont {
    margin-top: 100px;
  }
  .back-button-container {
    padding: 12px 16px 8px;
  }
  .back-button {
    padding: 8px 14px;
    font-size: 13px;
    gap: 6px;
  }
  .pub-header {
    padding: 20px 16px 12px;
    font-size: 12px;
    gap: 4px;
  }
  .blog-title {
    max-width: 90%;
    font-size: 22px;
    margin: 10px;
    line-height: 1.3;
    letter-spacing: -0.3px;
  }
  .blog-subtitle {
    font-size: 15px;
    margin: 18px;
    line-height: 1.55;
  }
  .blog-tags {
    padding: 0 16px 20px;
    gap: 6px;
  }
  .tag {
    padding: 4px 12px;
    font-size: 11px;
  }
  .blog-banner {
    margin: 0 16px 35px;
    border-radius: 10px;
  }
  .blog-banner img {
    max-height: 220px;
    border-radius: 0px;
    object-fit: contain;
  }
  .blog-content-wrapper {
    padding: 0 16px 40px;
  }
  .section-title {
    font-size: 22px;
    margin-bottom: 18px;
  }
  .blog-content {
    font-size: 15px;
    line-height: 1.7;
  }
  .blog-content p {
    margin-bottom: 16px;
  }
  .blog-content h2 {
    font-size: 22px;
    margin: 30px 0 16px;
  }
  .blog-content h3 {
    font-size: 19px;
    margin: 24px 0 12px;
  }
  .blog-content blockquote {
    padding: 15px 16px;
    margin: 20px 0;
    font-size: 14px;
    border-left-width: 3px;
  }
  .blog-content ul,
  .blog-content ol {
    padding-left: 24px;
    margin: 16px 0;
  }
  .blog-content li {
    margin-bottom: 8px;
  }
}
@media (max-width: 360px) {
  .blogs-cont {
    margin-top: 65px;
  }
  .back-button-container {
    padding: 10px 12px 6px;
  }
  .pub-header {
    padding: 16px 12px 10px;
  }
  .blog-title {
    font-size: 23px;
    margin: 10px 12px 8px;
  }
  .blog-subtitle {
    font-size: 14px;
    margin: 0 12px 15px;
  }
  .blog-tags {
    padding: 0 12px 18px;
  }
  .blog-banner {
    margin: 0 12px 30px;
  }
  .blog-banner img {
    height: 200px;
  }
  .blog-content-wrapper {
    padding: 0 12px 35px;
  }
  .section-title {
    font-size: 20px;
  }
  .blog-content {
    font-size: 14px;
  }
}
.blog-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 30px 0;
  font-size: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
.blog-content table thead {
  background-color: #00BCD4;
  color: #ffffff;
}
.blog-content table th,
.blog-content table td {
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: top;
}
.blog-content table th {
  font-weight: 600;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.blog-content table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
@media (hover: hover) {
  .blog-content table tbody tr:hover {
    background-color: #e0f7fa;
  }
}
.blog-content table {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.blog-content table::-webkit-scrollbar {
  height: 6px;
}
.blog-content table::-webkit-scrollbar-thumb {
  background-color: #00BCD4;
  border-radius: 10px;
}
/*# sourceMappingURL=blogs-read.component.css.map */
